export interface PivotConfig {

  dataSource: PivotDataSource;
  slice: PivotSliceDescriptor;
  options: any;
  formats: any[];
}

export class Pivot {
  public static readonly EMPTY_VALUE = {empty: true};
}

export interface PivotDataSource {

  data: any;

}

export interface PivotSliceDescriptor {
  rows: PivotRow[];
  columns: PivotColumn[];
  measures: PivotMeasure[];
  /*expands: {
    expandAll: false,
    rows: [
      {
        tuple: [
          "Destination.France"
        ]
      }
    ],
    columns: [
      {
        tuple: [
          "Category.Accessories"
        ]
      }
    ]
  },*/
  drills: {
    drillAll: false
  };
}


export interface PivotRow extends PivotDataField {

}

export interface PivotColumn extends PivotDataField {

}

export interface PivotMeasure extends PivotDataField {
  aggregation: PivotAggregation;
}

export interface PivotDataField {
  fieldName: string;
  sort?: Order;
}

export enum Order {
  asc, desc
}

export interface PivotDice {
  row?: PivotRow;
  column?: PivotColumn;
  measures?: PivotMeasure;
}

export interface PivotSlice extends PivotDice {
  element: any;
}


export class PivotAggregation {
  public static SUM = new PivotAggregation(function (data: any[]) {
    let aggregation = null;
    for (const element of data) {
      if (element === undefined || element == null) {

      } else {
        if (aggregation == null) {
          aggregation = 0;
        }
        aggregation += element;
      }
    }
    return aggregation;
  });

  public static AVG = new PivotAggregation(function (data: any[]) {
    let aggregation = null;
    let count = 0;
    for (const element of data) {
      if (element === undefined || element == null) {

      } else {
        if (aggregation == null) {
          aggregation = 0;
        }
        aggregation += element;
        count++;
      }
    }
    if (aggregation != null) {
      aggregation /= count;
    }
    return aggregation;
  });

  public static MIN = new PivotAggregation(function (data: any[]) {
    let aggregation = null;
    for (const element of data) {
      if (element === undefined || element == null) {

      } else {
        if (aggregation == null || element < aggregation) {
          aggregation = element;
        }
      }
    }
    return aggregation;
  });

  public static MAX = new PivotAggregation(function (data: any[]) {
    let aggregation = null;
    for (const element of data) {
      if (element === undefined || element == null) {

      } else {
        if (aggregation == null || element > aggregation) {
          aggregation = element;
        }
      }
    }
    return aggregation;
  });

  _func: (data: any[]) => any;

  constructor(func: (data: any[]) => any) {
    this._func = func;
  }
}
